
export function sessionGetItem<T>(key: string): T | null {
    const json = window.sessionStorage.getItem(key);
    if (json) {
        return JSON.parse(json) as T;
    }
    return null;
}

export function sessionSetItem<T>(key: string, data: T) {
    window.sessionStorage.setItem(key, JSON.stringify(data));
}



// WEBPACK FOOTER //
// ./src/helpers/storage.ts